import React from "react";
import "./footer.css";
import mailLogo from "../assets/email.jpg";
import PhoneLogo from "../assets/phone.jpg";
import InstagramLogo from "../assets/instalogo.jpg";
import LinkedinLogo from "../assets/linkedinlogo.jpg";
import Facebooklogo from "../assets/facebooklogo.jpg";

const Footer = () => {
  const iconSize = "26px";

  return (
    <footer className="footer">
      <div className="footer-icons left-icons">
        <a href="mailto:reachus@neelaverse.com">
          <img
            src={mailLogo}
            alt="Email"
            className="footer-icon"
            style={{ width: iconSize, height: iconSize }}
          />
        </a>

        <a href="tel:+918121956868" target="_blank" rel="noopener noreferrer">
          <img
            src={PhoneLogo}
            alt="Phone"
            className="footer-icon"
            style={{ width: iconSize, height: iconSize }}
          />
        </a>
      </div>

      <p className="footer-text">
        Empowering Innovation — NEELAverse Technologies © {new Date().getFullYear()}
      </p>

      <div className="footer-icons right-icons">
        <a
          href="http://facebook.com/NEELAverseTechnologies"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={Facebooklogo}
            alt="Facebook"
            className="footer-icon"
            style={{ width: iconSize, height: iconSize }}
          />
        </a>

        <a
          href="https://www.instagram.com/neelaverse_technologies"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={InstagramLogo}
            alt="Instagram"
            className="footer-icon"
            style={{ width: iconSize, height: iconSize }}
          />
        </a>

        <a
          href="https://www.linkedin.com/company/neelaverse"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={LinkedinLogo}
            alt="LinkedIn"
            className="footer-icon"
            style={{ width: iconSize, height: iconSize }}
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
